module.exports = __webpack_public_path__ + "img/電気回路_6_8.cd38a929.png";